// extracted by mini-css-extract-plugin
export var end = "flowNode-module--end--e06e3";
export var flowNode = "flowNode-module--flowNode--09416";
export var flowNodeBadge = "flowNode-module--flowNodeBadge--ac69d";
export var flowNodeLarge = "flowNode-module--flowNodeLarge--fe3ce";
export var flowNodeSmall = "flowNode-module--flowNodeSmall--62421";
export var flowNodeSubtext = "flowNode-module--flowNodeSubtext--70987";
export var flowNodeTitle = "flowNode-module--flowNodeTitle--cc464";
export var flowNodeTitleWrapper = "flowNode-module--flowNodeTitleWrapper--87311";
export var informationIcon = "flowNode-module--informationIcon--a3032";
export var no = "flowNode-module--no--76987";
export var yes = "flowNode-module--yes--40f51";